module.exports = __webpack_public_path__ + "static/sui-table-truncate-0919af126226ed225aa1c060f0c9cbfd.png";